import React, { Component } from "react";
import { Grid, Paper, Button, Divider, withStyles } from "@material-ui/core";
import clsx from "clsx";
import Navi_Buttons from "../../../components/forms/navi_buttons";
import { withRouter } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import shortfetch from "../../../components/data/fetch";
import CopyModelData from "../modellen/button_copy";
import AddNewModel from "../modellen/button_add_new";
import LoadingBar from "../../../components/data/loading";
import getBase64Image from "../../../components/forms/Base64_Encode";
import WarningBox from "../../../components/forms/warning_Box";
import CreateInput from "../../../components/form_input_fields";

const styles = {
  root: {
    flexGrow: 1,
    width: "100%",
    padding: 10,
  },
  paper: {
    padding: 5,
  },
};

class Form_Videos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      data_array: {},
      isLoading: true,
      select_items_list: {},
    };
  }

  async fetch_data(id) {
    let post_json = {
      id: id,
      type: "video_data",
      auth: localStorage.getItem("auth"),
    };
    console.log(JSON.stringify(post_json));

    let data = await shortfetch(post_json);

    console.log("fetched_data", data.data_array);

    this.setState({
      ori_data_array: JSON.stringify(data.data_array),
      data_array: data.data_array,
      isLoading: false,
      select_items_list: data,
    });
  }

  async save_data() {
    let post_json = {
      type: "save_data_video",
      data: this.state.data_array,
      auth: localStorage.getItem("auth"),
    };
    console.log(JSON.stringify(post_json));

    let data = await shortfetch(post_json);

    if (!data.geslaagd) {
      alert("Er is iets fout gegaan tijdens het opslaan.");
    }

    await this.fetch_data(this.state.data_array.VideoID);
  }

  componentDidMount() {
    this.fetch_data(this.props.match.params.id);
  }

  AlgemeenArray = [
    {
      name: "Video ID",
      data_key: "VideoID",
      data_type: "input",
      readonly: true,
    },
    {
      name: "Firma",
      data_key: "Firma",
      data_type: "input",
    },
    {
      name: "AfspeelMedium",
      data_key: "AfspeelMedium",
      data_type: "input",
    },
    {
      name: "Titel",
      data_key: "Titel",
      data_type: "input",
    },
    {
      name: "RegistratieCode",
      data_key: "RegistratieCode",
      data_type: "input",
    },
    {
      name: "Taal",
      data_key: "Taal",
      data_type: "input",
    },
    {
      name: "Jaartal",
      data_key: "Jaartal",
      data_type: "input",
    },
    {
      name: "Speeltijd Min",
      data_key: "Speeltijd Min",
      data_type: "input",
    },
    {
      name: "Betaald",
      data_key: "Betaald",
      data_type: "input",
    },
    {
      name: "CreateDatum",
      data_key: "CreateDatum",
      data_type: "input",
    },
  ];

  Change_Data(key, value) {
    let new_data_array = this.state.data_array;
    console.log("Key: " + key, "Value:" + value);
    new_data_array[key] = value;
    console.log(new_data_array);
    this.setState({ data_array: new_data_array });
  }

  Create_Input(item) {
    const { name } = item;

    return (
      <React.Fragment key={name}>
        <Grid
          container
          alignItems="center"
          style={{
            overflow: "hidden",
            width: "calc(99% - 5px)",
            padding: 5,
          }}
        >
          <Grid item xs={6}>
            {name + ":"}
          </Grid>
          <Grid item xs={6}>
            <CreateInput
              data={item}
              data_array={this.state.data_array}
              Change_Data={this.Change_Data.bind(this)}
              list={this.state.select_items_list}
            />
          </Grid>
        </Grid>
        <Divider></Divider>
      </React.Fragment>
    );
  }

  Change_State = (someArg) => {
    this.fetch_data(someArg);
    this.setState({ isLoading: true });
  };

  Delete_Image(Type, ID, e) {
    confirmAlert({
      title: "Foto verwijderen",
      message: `Weet je zeker dat je de ${Type} foto wilt verwijderen?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let post_json = {
              type: "delete_image",
              auth: localStorage.getItem("auth"),
              ModelID: ID,
              data: Type,
            };
            console.log(JSON.stringify(post_json));
            fetch("/api/fetch_data.php", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-form-urlencoded",
              },
              body: JSON.stringify(post_json),
            })
              .then((response) => response.json())
              .then((data) => {
                let succes;
                if (data.geslaagd) {
                  succes = "De foto is succesvol verwijderd.";
                } else {
                  succes = "Er is iets fout gegaan tijdens het verwijderen.";
                }
                alert(succes);
                document.getElementById("img" + Type).src =
                  "/media/Model_images/Placeholder.jpg";
              });
          },
        },
        {
          label: "No",
        },
      ],
    });
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingBar />;
    }

    const { classes, className } = this.props;
    const { VideoID } = this.state.data_array;
    const NaviButtonsWithRouter = withRouter(Navi_Buttons);
    const CopyModelDataWithRouter = withRouter(CopyModelData);
    const AddNewModelWithRouter = withRouter(AddNewModel);

    return (
      <div style={{ marginBottom: 250 }}>
        <WarningBox
          ShowError={
            this.state.ori_data_array === JSON.stringify(this.state.data_array)
          }
        />
        <Grid container style={{ width: "calc(100% - 8px)" }}>
          <Grid item xs={3} container justify="center" alignItems="center">
            <Grid item>
              <AddNewModelWithRouter
                Change_State={this.Change_State}
                max={this.state.select_items_list.total}
                ModelID={this.state.data_array.ModelID}
              />
            </Grid>
          </Grid>
          <Grid item xs={3} container justify="center" alignItems="center">
            <Grid item>
              <Button
                onClick={() => this.save_data()}
                style={{ background: "white" }}
              >
                Opslaan
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <NaviButtonsWithRouter
              value={this.props.match.params.id}
              Change_State={this.Change_State}
              max={this.state.select_items_list.total}
            />
          </Grid>
          <Grid
            className={clsx(classes.root, className)}
            item
            x={12}
            container
            spacing={1}
          >
            <Grid item xs={6}>
              <video
                style={{
                  width: "calc(100% - 8px)",
                  maxHeight: "calc(50vh)",
                  maxWidth: "calc(100%)",
                }}
                controls
                autoPlay={false}
              >
                <source
                  src={`/media/Video's/video-${VideoID}/video.webm`}
                  type="video/webm"
                />
                Your browser does not support the video tag.
              </video>
            </Grid>
            <Grid item xs={6}>
              <Paper className={clsx(classes.paper)}>
                <h3>Algemeen</h3>
                <Divider></Divider>
                {this.AlgemeenArray.map((item) => {
                  return this.Create_Input(item);
                })}
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={clsx(classes.paper)}>
                <h3>Foto's</h3>
                <Divider></Divider>
                <Grid container justify="center">
                  {[
                    { name: "voorkant", size: 3 },
                    { name: "achterkant", size: 3 },
                    { name: "binnenkant", size: 3 },
                  ].map((item) => {
                    return (
                      <Grid
                        item
                        xs={item.size}
                        container
                        alignItems="center"
                        style={{
                          overflow: "auto",
                          width: "calc(100% - 5px)",
                          padding: 5,
                        }}
                        key={item.name}
                      >
                        <img
                          src={
                            `/media/Video's/video-${VideoID}/${item.name}.jpg?` +
                            new Date().getTime()
                          }
                          style={{
                            width: "100%",
                            borderRadius: 7,
                            border: "black 2px solid",
                          }}
                          onClick={(e) =>
                            this.Delete_Image(item.name, VideoID, e)
                          }
                          onError={(e) => {
                            e.target.onError = null;
                            e.target.src =
                              "/media/Model_images/Placeholder.jpg";
                          }}
                          id={"img" + item.name}
                        ></img>
                        <Grid item xs={6}>
                          {item.name}
                        </Grid>
                        <Grid item xs={6}>
                          <input
                            type="file"
                            id={"imgInput" + item.name}
                            name={item.name}
                            //value={this.state.data_array[data_key]}
                            style={{
                              width: "100%",
                              fontSize: "120%",
                              display: "none",
                            }}
                            onChange={(e) =>
                              getBase64Image(e.target.files[0]).then((value) =>
                                this.Change_Data(item.name, value)
                              )
                            }
                          ></input>
                          <label htmlFor={"imgInput" + item.name}>
                            <Button
                              component="span"
                              className={classes.button}
                              style={{
                                background: "grey",
                              }}
                            >
                              Upload
                            </Button>
                          </label>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
                <Divider></Divider>
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={clsx(classes.paper)}>
                <Grid container justify="center" alignItems="center">
                  <Grid
                    item
                    xs={12}
                    container
                    justify="center"
                    alignItems="center"
                  >
                    <Button
                      onClick={() => this.save_data()}
                      style={{ background: "#D3D3D1", width: "80%" }}
                    >
                      Opslaan
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(Form_Videos);
